import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";
import { DRAGLEAVE_COMMAND } from "../types/commands";

import type { FC } from "react";

export const DragEventsPlugin: FC = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const handleEvent = (event: DragEvent): void => {
      if (editor.isEditable()) {
        editor.dispatchCommand(DRAGLEAVE_COMMAND, event);
      }
    };

    editor.getRootElement()?.addEventListener("dragleave", handleEvent);

    return () => {
      editor.getRootElement()?.removeEventListener("dragleave", handleEvent);
    };
  });

  return null;
};
